module.exports = __webpack_public_path__ + "static/media/sam_copeland.7815c243.png";